import { render, staticRenderFns } from "./FeatureValueForm.vue?vue&type=template&id=9796c69a&"
import script from "./FeatureValueForm.vue?vue&type=script&lang=js&"
export * from "./FeatureValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports